import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../../../components/Container/pageContainer'
import { UserInterFace } from '../../../constant/Website';
import CustomForm from '../../../components/form/form';
import { Box, Card, Grid, Typography } from '@mui/material';
import Logo from '../../../components/Logo/Logo';
import { useTheme } from '@emotion/react';
import { useParams } from 'react-router-dom';
import {useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { ShowLoader } from '../../../redux/actions/loader';
import logo from '../../../assets/images/newLogo.png'

const VerifyMarksheet = (props) => {
    const [ data , setData ] = useState(UserInterFace.marksheetVerify);
    const { srn } = useParams();
    const url = useSelector((state) => state.Api);
    const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
        const [studentDetails , setstudentDetails] = useState();
      const dispatch = useDispatch();
    
     const verifyMark = (resultSrn) => {
         try {
            axios.get(`${url.VerifiyMarksheet}/${resultSrn}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userToken}`,
            },
            })
            .then((res) => {
            if (res.status === 200) { 
                dispatch(ShowLoader('0'));
                setstudentDetails(res?.data?.message[0])
            }
            })
            .catch((err) => {
                dispatch(ShowLoader('0'));
            });
        } catch (err) {
                dispatch(ShowLoader('0'));
        }
     }
  useEffect(() => {
    verifyMark(srn)
    // Call API to verify marksheet
    // GET /api/verify/marksheet/{srn}
            // dispatch(ShowLoader('0'));
    
  }, [srn]);
     
    const theme = useTheme();
    const style = theme.palette.Main.login;
  return (
    <PageContainer title={data.title} description={data.description}>
        <Box  sx={style.mainbox}>
                <Grid container spacing={0} justifyContent="center" sx={{ height: '100vh' }}>
           
                <Grid item
                    xs={12}
                    sm={12}
                    lg={4}
                    xl={3}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Card elevation={9} sx={{ p: 4, minHeight: '390px', zIndex: 1, width: '100%', width: '700px' }}>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        {/* <Logo /> */}
                        <img src={logo} />
                    </Box>
                        {/* <CustomForm data={data.inputs} handleInputChange={handleInputChange} /> */}
                        <Box mt={2}>
                            <Grid container>
                                <Grid item lg={12} className='resultCard' style={{textAlign: 'center',
    fontSize: '29px',
    lineHeight: '1.6',
    fontWeight: 'bold'}}>
                                    <Typography variant='p'>
                                        رول نمبر: {studentDetails?.RollNum} 
                                    </Typography>
                                    <br/>
                                    <Typography variant='p'>
                                       {studentDetails?.Name_P}  ولد {studentDetails?.FName_P} 
                                    </Typography>
 
                                    {/* <Typography variant='p'>
                                        پلار نوم: {studentDetails?.FName_P} 
                                    </Typography> */}


                                    <br/>
                                    <Typography variant='p'>
                                         {studentDetails?.Class} 
                                    </Typography>
                                    
                                    <br/>
                                    <br/>
                                    <Typography variant='p'>
                                         نتیجه: {studentDetails?.Status} 
                                    </Typography>


{/*                                     
                                    <Typography variant='p'>
                                        Secured Marks :- 500د رول نمبر {studentDetails?.RollNum}، د زده‌کوونکي نوم {studentDetails?.name} د پلار نوم {studentDetails?.fName} پایله «{studentDetails?.Status}» ده، او دا تعلیمي ریکارډ په رسمي ډول کره بلل کېږي۔
                                    </Typography> */}
                                </Grid>
                                 
                            </Grid>
                        </Box>
                        {/* <Box display="flex" mt={1}>
                            <Typography variant='h5' mr={2}>
                                Status :-
                            </Typography>
                            <Typography variant='p' mt={.4}>
                                Pass
                            </Typography>
                        </Box> */}
                    </Card>
                    </Grid>
                </Grid>
            </Box>
    </PageContainer>
  )
}


VerifyMarksheet.propTypes = {}

export default VerifyMarksheet